import React, { useMemo, useState } from 'react';
// import useSentryContext from '../utils/sentryContext';
const SideBarContext = React.createContext();

const SideBarProvider = ({ children }) => {
    const [current, setCurrent] = useState(["dashboard"]);
    // const snapshot = useMemo(() => ({ current }), [current]);
    // useSentryContext("sidebarContext", snapshot);
    return (
        <SideBarContext.Provider value={{current, setCurrent}}>
            {children}
        </SideBarContext.Provider>
    );
}

export { SideBarContext, SideBarProvider };